import { getRequest } from '../services/requestHandler';
import { PutterWeight } from '../models';

export const getPutterWeights = async () => {
  const url = 'putter/getPutterWeights?activeOnly=true&useCache=false';
  const response = await getRequest<PutterWeight>('GetPutterWeights', url);
  return response;
};
